module.exports = __webpack_public_path__ + "img/manajemen_pos_cabang_&di-pickup.61c40744.svg";